import { z } from 'zod';
export const SMTP_ACCOUNT_STATUSES = ['active', 'paused', 'error'];
export const smtpAccountCreateSchema = z.object({
    project_id: z.string().uuid(),
    label: z.string().min(1).max(120),
    from_email: z.string().email().max(320),
    smtp_host: z.string().min(1).max(253),
    smtp_port: z.number().int().min(1).max(65535).default(587),
    smtp_secure: z.boolean().default(false),
    smtp_user: z.string().min(1).max(320),
    smtp_password: z.string().min(1).max(512),
    imap_host: z.string().min(1).max(253).optional().nullable(),
    imap_port: z.number().int().min(1).max(65535).optional().nullable(),
    imap_secure: z.boolean().optional().nullable(),
    imap_user: z.string().max(320).optional().nullable(),
    imap_password: z.string().max(512).optional().nullable(),
    daily_limit: z.number().int().min(1).max(500).optional(),
    hourly_limit: z.number().int().min(1).max(100).optional(),
    from_name: z.string().max(200).optional().nullable(),
    reply_to: z.string().email().max(320).optional().nullable(),
    signature_html: z.string().max(20000).optional().nullable(),
    is_default: z.boolean().optional(),
});
export const smtpAccountUpdateSchema = smtpAccountCreateSchema
    .partial()
    .omit({ project_id: true })
    .extend({
    status: z.enum(SMTP_ACCOUNT_STATUSES).optional(),
    smtp_password: z.string().min(1).max(512).optional(),
    imap_password: z.string().min(1).max(512).optional(),
});
export const mailSendSchema = z.object({
    lead_id: z.string().uuid(),
    smtp_account_id: z.string().uuid().optional(),
    subject: z.string().min(1).max(998),
    body_text: z.string().min(1).max(100_000),
    body_html: z.string().max(200_000).optional().nullable(),
});
/** Reply to an existing mail_messages row (typically inbound). */
export const mailReplySchema = z.object({
    subject: z.string().min(1).max(998).optional(),
    body_text: z.string().min(1).max(100_000),
    body_html: z.string().max(200_000).optional().nullable(),
    smtp_account_id: z.string().uuid().optional(),
    lead_id: z.string().uuid().optional(),
});
export const mailImapSyncSchema = z.object({
    reset_inbox: z.boolean().optional(),
    reset_sent: z.boolean().optional(),
});
//# sourceMappingURL=smtpAccount.js.map